module.exports = __webpack_public_path__ + "static/media/phone-icon.58edbe76.svg";